stimulusApp.register(
  "sticky-navbar",
  class extends Stimulus.Controller {
    static targets = ["link"]
    static classes = ["active"]

    #observer

    connect() {
      this.#observer = new IntersectionObserver(
        (entries) => this.#onIntersect(entries),
        { rootMargin: "-30% 0px -60% 0px" },
      )
      this.#sections.forEach((section) => this.#observer.observe(section))
    }

    disconnect() {
      this.#observer?.disconnect()
    }

    #onIntersect(entries) {
      const visible = entries.find((entry) => entry.isIntersecting)
      if (!visible) return

      this.linkTargets.forEach((link) => {
        link.classList.toggle(
          this.activeClass,
          link.getAttribute("href") === `#${visible.target.id}`,
        )
      })
    }

    get #sections() {
      return this.linkTargets
        .map((link) => document.querySelector(link.getAttribute("href")))
        .filter(Boolean)
    }
  },
)
